import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import "./styles.css";

// Theme: explicit choice persists; otherwise follow the system (tokens.css handles both).
try {
  const t = localStorage.getItem("cb-theme");
  if (t === "dark" || t === "light") document.documentElement.dataset["theme"] = t;
} catch { /* ignore */ }

// Dev-only viewport harness: `?vw=390` renders the app inside an iframe of that width so CSS media
// queries respond to it (the browser tools cannot resize the window). Never active in production builds.
const vw = import.meta.env.DEV ? Number(new URLSearchParams(location.search).get("vw")) : 0;
if (vw > 0 && window.self === window.top) {
  const url = new URL(location.href); url.searchParams.delete("vw");
  const vh = Number(new URLSearchParams(location.search).get("vh")) || Math.max(600, window.innerHeight - 40);
  document.body.style.cssText = "margin:0;background:#888;display:flex;justify-content:center;align-items:flex-start;padding:20px";
  const f = document.createElement("iframe");
  f.src = url.toString(); f.style.cssText = `width:${vw}px;height:${vh}px;border:0;background:#fff;box-shadow:0 0 0 1px #555`; f.title = `viewport ${vw}`;
  document.getElementById("root")!.replaceWith(f);
} else {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
}
